import { atom, useAtom } from 'jotai';

const defaultSortingAtom = atom<boolean>(false);
export const useProjectGroupSorting = () => {
  defaultSortingAtom.debugLabel = 'projectGroupSorting';
  const [projectGroupSorting, setProjectGroupSorting] = useAtom(defaultSortingAtom);

  return {
    projectGroupSorting,
    setProjectGroupSorting,
  };
};

const defaultHeadingAtom = atom<string>('');
export const useProjectGroupHeading = () => {
  defaultHeadingAtom.debugLabel = 'defaultHeadingAtom';
  const [projectGroupHeading, setProjectGroupHeading] = useAtom(defaultHeadingAtom);

  return {
    projectGroupHeading,
    setProjectGroupHeading,
  };
};
